import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CaluButton from '@/components/styledComponents/CaluButton'
import { getClinicHistoriesBackup } from '@/store/clinicHistory/actions'
import { RESET_BACKUP_PATIENTS } from '@/store/patientCentres'
import convertCSVToExcelAndDownload from '@/utils/functions/convertCSVToExcelAndDownload'
import { showToast } from '@/utils/toast'

import dayjs from 'dayjs'
import BackupPatients from './backupPatients'

import s from './styles.module.scss'

const TabBackups = () => {
  const dispatch = useDispatch()

  const centreDetail = useSelector((state) => state.centres.centreProfile)
  const { isLoading } = useSelector((state) => state.clinicHistory)

  const [openPopUpBackupPatients, setOpenPopUpBackupPatients] = useState(false)
  const [downloadingYear, setDownloadingYear] = useState(null)

  const centreCreationYear = centreDetail?.creationDate ? dayjs(centreDetail.creationDate).year() : undefined

  const getYearsRange = (startYear) => {
    if (!startYear) return []
    const currentYear = dayjs().year()
    const years = []
    for (let y = startYear; y <= currentYear; y++) {
      years.push(y)
    }
    return years
  }

  const years = useMemo(() => getYearsRange(centreCreationYear), [centreCreationYear])

  const handleDownloadBackupHC = async (year) => {
    setDownloadingYear(year)
    const csvContent = await dispatch(getClinicHistoriesBackup(centreDetail?._id, year))
    if (csvContent) {
      try {
        convertCSVToExcelAndDownload(csvContent, `backup_fichas_${centreDetail?.name}_${year}`)
      } catch (error) {
        showToast('Se produjo un error en la descarga', 'error')
      } finally {
        setDownloadingYear(null)
      }
    }
  }

  const handleClosePopUpBackupPatients = async (event, reason) => {
    if (reason && reason === 'backdropClick') return
    setOpenPopUpBackupPatients(false)
    dispatch(RESET_BACKUP_PATIENTS())
  }

  return (
    <div className={s.mainContainer}>
      <div className={s.itemContainer}>
        <p>Backup de Historias Clínicas</p>
        <div className={s.contCaluButton}>
          {years?.map((year) => (
            <CaluButton
              color="primary"
              size="small"
              onClick={() => handleDownloadBackupHC(year)}
              loading={isLoading && downloadingYear === year}
              key={year}
            >
              {year}
            </CaluButton>
          ))}
        </div>
      </div>
      <div className={s.itemContainer}>
        <p>Backup de Pacientes</p>
        <div className={s.contCaluButton}>
          <CaluButton color="primary" size="small" onClick={() => setOpenPopUpBackupPatients(true)}>
            Descargar
          </CaluButton>
        </div>
      </div>

      <BackupPatients open={openPopUpBackupPatients} handleClose={handleClosePopUpBackupPatients} />
    </div>
  )
}

export default TabBackups
